import {
	ApplicationConfig,
	provideAppInitializer,
	provideZoneChangeDetection
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';

import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi
} from '@angular/common/http';
import { routes } from './app.routes';
import { keycloak } from './core/auth/keykloak.config';
import { httpRequestInterceptor } from './core/interceptors/http-request.interceptor';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import {
	User,
	UserPlus,
	UserCog,
	LogOut,
	Lock,
	CircleArrowUp,
	X,
	Menu,
	ChevronDown,
	CircleAlert,
	RefreshCw,
	Pencil,
	Trash2,
	MapPinOff,
	CircleCheck,
	TriangleAlert,
	ArrowLeft,
	ArrowRight,
	LayoutGrid,
	Plus,
	Save,
	Search,
	Eye,
	EyeOff,
	Home,
	Info,
	Phone,
	Mail,
	MapPin,
	Check,
	Settings,
	Shield,
	CircleUser,
	RotateCcw,
	Ban,
	CalendarDays,
	Trees,
	Landmark,
	Building2,
	Drama,
	Gavel,
	Trophy,
	HeartHandshake,
	GraduationCap,
	Film,
	HardHat,
	Briefcase,
	MessageCircle,
	Stethoscope,
	Wrench,
	Car
} from 'lucide-angular';

function initKeycloak() {
	return () =>
		keycloak.init({
			onLoad: 'check-sso', // 👈 CLAVE
			pkceMethod: 'S256',
			checkLoginIframe: false
		});
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideAnimationsAsync(),
		provideAppInitializer(initKeycloak()),
		provideHttpClient(withInterceptorsFromDi()),
		{
			provide: HTTP_INTERCEPTORS,
			useClass: httpRequestInterceptor,
			multi: true
		},
		{
			provide: LUCIDE_ICONS,
			multi: true,
			useValue: new LucideIconProvider({
				User,
				UserPlus,
				UserCog,
				LogOut,
				Lock,
				CircleArrowUp,
				X,
				Menu,
				ChevronDown,
				CircleAlert,
				RefreshCw,
				Pencil,
				Trash2,
				MapPinOff,
				CircleCheck,
				TriangleAlert,
				ArrowLeft,
				ArrowRight,
				LayoutGrid,
				Plus,
				Save,
				Search,
				Eye,
				EyeOff,
				Home,
				Info,
				Phone,
				Mail,
				MapPin,
				Check,
				Settings,
				Shield,
				CircleUser,
				RotateCcw,
				Ban,
				CalendarDays,
				Trees,
				Landmark,
				Building2,
				Drama,
				Gavel,
				Trophy,
				HeartHandshake,
				GraduationCap,
				Film,
				HardHat,
				Briefcase,
				MessageCircle,
				Stethoscope,
				Wrench,
				Car
			})
		}
	]
};
